<template>
    <v-container fluid style="padding-bottom: 0;">
        <v-layout column wrap>
            <v-flex grow>
                <v-layout row fill-height wrap>
                    <v-flex
                    >
                    <v-card style="height: 100%;">
                        <v-card-title>
                            <v-layout row style="margin: 0;" align-center justify-space-between>
                                <v-flex shrink>
                                    <h2 style="font-size: 1.5em; display: inline-block;">Datenschutzbeauftragte</h2>
                                </v-flex>
                               
                                <v-flex shrink>
                                    <v-select 
                                        :items="clients"
                                        v-model="currentClient"
                                        item-text="name"
                                        return-object
                                        label="Unternehmen"
                                        @change="updateUserDatatable($event)"
                                    />
                                </v-flex>
                            </v-layout>
                            
                            
                        </v-card-title>
                        <datatable
                            :items="userArray"
                            :headers="headers"
                            :pagination.sync="pagination"
                            :no-data-text="'Es wurden noch keine Datenschutzbeauftragte hinzugefügt'"
                        >
                            <template v-slot:items="props">
                                <td>
                                    <template v-if="props.item.firstname">
                                        {{props.item.firstname}}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                                <td>
                                    <template v-if="props.item.lastname">
                                        {{props.item.lastname}}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                                <td>
                                    <v-layout row>
                                        <v-flex grow>{{props.item.email}}</v-flex>
                                        <v-flex shrink>
                                            <span v-if="!props.item.isActivated" style="background-color: orange; border-radius: 4px; padding: 0 4px; white-space: nowrap;">nicht aktiviert</span>
                                        </v-flex>
                                        <v-flex shrink v-if="props.item.emailFailure == 1" >
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn small class="error--text" icon v-on="on">
                                                        <v-icon small>warning</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Die E-Mail-Adresse ist ungültig.</span>
                                            </v-tooltip>
                                        </v-flex>
                                    </v-layout>
                                </td>
                                <td>
                                    <v-btn 
                                        :id='"delete-dsk: " + props.item.firstname + " " + props.item.lastname'
                                        icon
                                        @click="deleteConfirmationDsk = true; deleteDsbId = props.item;"
                                    >
                                        <v-icon >delete</v-icon>
                                    </v-btn>
                                </td>  
                            </template>
                        </datatable>
                        <v-flex shrink>
                            <v-layout row style="padding: 0 16px;">
                                <v-flex 
                                    :shrink="$vuetify.breakpoint.smAndUp"
                                    :grow="$vuetify.breakpoint.xs"
                                >
                                    <div>
                                    <v-btn id="add-dsk" block @click="addNewDSB()" color="white">
                                        Neuen Datenschutzbeauftragten einladen
                                        <v-icon>add</v-icon>
                                    </v-btn>
                                    </div>
                                    <br>
                                    <div>
                                
                                </div>
                                </v-flex>
                                
                            </v-layout>
                        </v-flex>
                    </v-card>
                    </v-flex>
                </v-layout>
                <v-dialog
                    v-model="showDSBForm"
                    max-width="600"
                    persistent
                >
                    <v-card 
                    class="mx-auto"
                    v-if="DSBToEdit!=null"
                    >
                        <v-card-title class="headline">
                            <v-spacer></v-spacer>
                                DSB einladen
                            <v-spacer></v-spacer>
                        </v-card-title>

                        <v-container fluid>
                            <v-form xs12 sm6 offset-sm1 ref="DSBInviteForm">
                                <v-layout column fluid>
                                    <v-flex>
                                        <v-text-field
                                            id="email"
                                            v-model="DSBToEdit.email"
                                            label='E-Mail'
                                            required
                                            :rules="[rules.required, rules.email]"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row v-if="DSBToEdit.msg">
                                    <v-alert
                                        :value="DSBToEdit.msg !== ''"
                                        color="error"
                                        outline
                                    >
                                        <span style="white-space: pre;">{{DSBToEdit.msg}}</span>
                                    </v-alert>
                                </v-layout>
                            </v-form>
                                <v-layout row v-if="DSBToEdit.error">
                                    <v-alert
                                        :value="DSBToEdit.error !== ''"
                                        color="error"
                                        outline
                                    >
                                        {{DSBToEdit.error}}
                                    </v-alert>
                                </v-layout>
                                <v-layout row>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="showDSBForm=false, DSBToEdit=null">
                                        Abbrechen
                                    </v-btn>
                                    <v-btn @click="inviteDSB()">
                                        Einladen
                                    </v-btn>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-dialog>
            </v-flex>  

            <v-dialog
                v-model="deleteConfirmationDsk"
                max-width="400"
            >
                <v-card>
                <v-card-title class="headline">Möchten Sie die Rolle des Nutzers wirklich löschen?</v-card-title>
                    <v-card-text>
                        Die Rolle wird unwiderruflich gelöscht.
                    </v-card-text>

                <v-card-actions>
                    <v-btn
                    id="aboart-delete-dsk"
                    @click="deleteConfirmationDsk = false"
                    >
                    Abbrechen
                    </v-btn>

                    <v-btn
                    id="confrim-delete-selected-dsk"
                    color="red  white--text"
                    @click="deleteConfirmationDsk=false, confirmDeleteDsb()"
                    >
                    Löschen
                    </v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>

</template>

<script>
import DatatableVue from './Datatable.vue'


export default {
    name: 'DatatableDsbs',

    components: {
        "datatable": DatatableVue
    },

    data: () => ({
        pagination: {sortBy: 'email'},

        search: '',

        userArray: [],

        clients: [],
        currentClient: null,

        showDSBForm: false,
        deleteConfirmationDsk: false,

        DSBToEdit: null,
        deleteDsbId: {},

        headers: [
            { text: 'Vorname', value: 'firstname' },
            { text: 'Nachname', value: 'lastname' },
            { text: 'E-Mail', value: 'email' },
            { text: '', value: 'name', sortable: false }
        ],

        rules: {
                required: value => !!value || 'Erforderlich',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Ungültige E-Mail-Adresse'
                    },
                confirm: value => {
                    return value == this.user.password || 'Passwörter sind nicht identisch'
                }
            }
    }),
    computed: {
        userRole() {
            return this.$store.state.userRole
        },
    },

    watch: {
        userRole(newRole) {
            if(newRole == "DSB") this.fetchDatatableData()
        }
    },
    methods: {
        log(item) {
            console.log(item)
        },
        updateUserDatatable(value) {
            const clientId = value.clientId;
            let self = this
            this.axios.axiosCall({
                url: actionUrl + "rest/monitor/dsbs",
                data: {
                    userRole: self.$store.state.userRole.role,
                    clientId
                },
                blockGui: false,
                success: function(response) {
                    self.setDSBs(response.data);
                }
            })
        },
        setDSBs(users) {
            this.userArray = [];
            for(let user of users){
                this.userArray.push(user);
            }
        },
        addNewDSB(){
            this.DSBToEdit = {firstname:"", lastname:"", email:"", clientId:'', cc: "", error: '', msg: ''}
            this.showDSBForm = true
        },
        inviteDSB(){
            let self = this
            if (this.$refs.DSBInviteForm.validate()){
                let data = {
                    clientId: this.currentClient.clientId,
                    'email': self.DSBToEdit.email.trim().toLowerCase(),
                    inviteRole: 'DSB'
                }
                this.axios.axiosCall({
                    url: actionUrl + "rest/user/invite",
                    data: data,
                    blockGui: false,
                    success: function(response) {
                        if(!response.data.error) {
                            self.fetchDatatableData();
                            EventBus.$emit('updateRoles');
                            if(response.data.success) self.showDSBForm = false;
                            self.DSBToEdit.msg = response.data.msg;
                            
                        } else {
                            self.DSBToEdit.error = response.data.error;
                        }

                    }

                })
            }
            
        },
        editDSK(item) {
            if(this.$refs.DSKForm.validate()){
                this.showDSBForm = false
            }
        },
        confirmDeleteDsb() {
            this.deleteConfirmationDsk = false;
            let self = this;
            this.axios.axiosCall({
                url: actionUrl + "rest/user/role/delete/" + this.deleteDsbId.userId,
                data: {
                    clientId: this.currentClient.clientId,
                    deleteRole: 'DSB'
                },
                blockGui: false,
                success: function(response) {
                    self.fetchDatatableData();
                    if(self.deleteDsbId.clientId == self.$store.state.currentClient.clientId) {
                        if(self.$store.state.user.email == self.deleteDsbId.email) EventBus.$emit('updateRoles');
                    }
                }
            });
        },
        fetchDatatableData() {
            let self = this
            this.axios.axiosCall({
                url: actionUrl + "rest/user/superAdminAllClients",
                method: 'get',
                success: function(response) {
                    self.setDatatableData(response.data.clients)
                }
            })
        },

        setDatatableData(clients) {
            this.clients = []
            for(let client of clients){
                this.clients.push(client);
            }
            if(this.currentClient === null) {
                this.currentClient = this.clients[0];
            }
            this.updateUserDatatable(this.currentClient);
        },
        
    },
    mounted() {
        this.fetchDatatableData();
    }
}
</script>

<style>
.datatable-dsks .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    margin: 0;
}
.datatable-dsks .theme--light.v-messages {
    min-height: 0 !important;
}
</style>
